import { createFeatureSelector, createSelector } from '@ngrx/store';

import { Loadable } from '®shared/data';
import { ReadingListDetails } from '®shared/reading-list';

export const STATE_FEATURE_LISTS_FOR_RESOURCE = 'lists-for-resources';

export interface ListsForResourceState {
  listsForResource: Loadable<ReadingListDetails[]> | null;
}

export const INITIAL_LISTS_FOR_RESOURCE_STATE: ListsForResourceState = {
  listsForResource: null,
};

export function getInitialListForResourceState(): ListsForResourceState {
  return INITIAL_LISTS_FOR_RESOURCE_STATE;
}

export const selectListsForResourceState =
  createFeatureSelector<ListsForResourceState>(
    STATE_FEATURE_LISTS_FOR_RESOURCE,
  );

type ReadingList = { title: string };
const compareListsFn = (a: ReadingList, b: ReadingList) =>
  a.title.localeCompare(b.title);

export const selectSortedListsForResource = createSelector(
  selectListsForResourceState,
  state =>
    !state.listsForResource.data
      ? []
      : [...state.listsForResource.data].sort(compareListsFn),
);
